<template>
  <div class="page-container flex-row">
    <div class="page_container_content flex-column col-1">
      <div class="col-0 pd10 flex-row flex-wrap item-center">
        <div class="mr10 mb5 flex-row item-center">
          <span class="mr5 col-0">文件名</span>
          <el-input v-model="filename" clearable placeholder="搜索关键词" size="mini" />
        </div>
        <div class="mr10 mb5 flex-row item-center">
          <span v-if="isAdmin" class="mr5 col-0">上传人</span>
          <el-autocomplete
            v-if="isAdmin"
            v-model="uploader"
            clearable
            :fetch-suggestions="querySearch"
            size="mini"
            placeholder="搜索关键词"
            class="mr10 mb5 flex-row item-center"
          />
        </div>
        <div class="mr10 mb5 flex-row item-center">
          <span class="mr5 col-0">邮箱</span>
          <el-input v-model="email" clearable placeholder="来源、或接收邮箱" size="mini" />
        </div>
        <div class="mr10 mb5 flex-row item-center">
          <span class="mr5 col-0">上传时间</span>
          <el-date-picker
            v-model="daterange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            size="mini"
            :picker-options="datepickerOptions"
          ></el-date-picker>
        </div>
        <div class="mr20">
          <el-button :loading="loading" type="primary" size="mini" @click="getData">搜索</el-button>
        </div>
        <div>
          <el-button
            :loading="exportPending"
            :disabled="!selection || selection.length === 0"
            type="primary"
            size="mini"
            @click="exportExcel"
            >导出选中文件</el-button
          >
        </div>
      </div>
      <div ref="tableWrapper" class="col-1">
        <el-table
          ref="table"
          v-loading="loading"
          :data="list"
          :height="height"
          border
          size="mini"
          @selection-change="onSelectionChange"
        >
          <el-table-column type="index" align="center" width="45" />
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column label="操作" align="center" width="70">
            <template slot-scope="scope">
              <a class="mr10" href="javascript:void(0);" @click="showDialog(scope.row)">
                <i class="el-icon-circle-plus" />关联
              </a>
            </template>
          </el-table-column>
          <el-table-column label="文件名" width="300">
            <template slot-scope="scope">
              <a href="javascript:void(0);" class="mr5" @click="preview(scope.row)">{{ scope.row.filename || '--' }}</a>
            </template>
          </el-table-column>
          <el-table-column column-key="关联" label="关联" width="400">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.links" :key="index" class="col-1 mb5 flex-row item-center">
                <div class="col-1">
                  <span v-if="item.fileType" class="mr10">{{ item.fileType }}</span>
                  <a
                    v-if="item.id && item.idField === 'rid'"
                    href="javascript:void(0);"
                    @click="showRadishDetail({ id: item.id, title: item.link })"
                    >{{ item.link }}</a
                  >
                  <div v-else :title="item.link">{{ item.link }}</div>
                </div>
                <a
                  class="pointer ft-danger col-0"
                  href="javascript:void(0);"
                  @click="cancelLink(scope.row, item, index)"
                >
                  <i class="el-icon-delete" />删除
                </a>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="上传时间" width="100">
            <template slot-scope="scope">
              {{ scope.row.createdAt ? dateFormat(new Date(scope.row.createdAt), 'yyyy-mm-dd') : '' }}
            </template>
          </el-table-column>
          <el-table-column sortable label="来源邮箱" prop="from">
            <template slot-scope="scope">{{ scope.row.from && scope.row.from.toString() }}</template>
          </el-table-column>
          <el-table-column sortable label="接收邮箱" prop="to">
            <template slot-scope="scope">{{ scope.row.to && scope.row.to.toString() }}</template>
          </el-table-column>
          <el-table-column sortable label="上传人" width="100" prop="uploader">
            <template slot-scope="scope">{{ scope.row.uploader && scope.row.uploader.toString() }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[100, 200, 500]"
          :page-size="pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        />
      </div>
    </div>
    <LinkFile
      :visible.sync="dialogVisible"
      :link-target="linkTarget"
      :search-keywords="searchKeywords"
      @onLink="confirmLink"
    />
  </div>
</template>

<script>
import LinkFile from '../dialog/LinkFile.vue'
import { objectPickBy, initialize2DArray, preview, download } from '../constant/utils'

const dateFormat = require('dateformat')

const i18n = {
  filename: '文件名',
  createdAt: '上传时间',
  uploader: '上传人',
  from: '来源邮箱',
  to: '接收邮箱',
}

export default {
  components: { LinkFile },
  data() {
    return {
      height: undefined,
      list: [],
      page: 1,
      pageSize: 100,
      total: 0,
      loading: false,
      searchResult: [],
      filename: '',
      uploader: '',
      daterange: '',
      email: '',
      exportPending: false,
      selection: [],
      dialogVisible: false,
      searchKeywords: '',
      linkTarget: {},
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    root() {
      return window.app.root
    },
    isAdmin() {
      return window.app.user['角色'] && window.app.user['角色'].includes('管理员')
    },
    datepickerOptions() {
      return {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      }
    },
    preview() {
      return preview
    },
    download() {
      return download
    },
  },
  watch: {
    loading(value, oldValue) {
      if (!value && !this.height) {
        this.initHeight()
      }
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      if (this.loading) return
      const { page, pageSize } = this
      this.loading = true
      this.selection = []
      try {
        const query = {
          filename: this.filename,
          uploader: this.uploader,
          daterange: this.daterange,
          email: this.email,
          paginate: {
            page,
            pageSize,
          },
        }
        const { data, total } = await window.app.service('file').wechatFiles(query)
        this.total = total
        this.list =
          data.map(item => {
            if (!item.links) item.links = []
            return item
          }) || []
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    initHeight() {
      if (!this.$refs.tableWrapper) return
      const { height } = this.$refs.tableWrapper.getBoundingClientRect()
      this.height = height - 40
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    pageChange(val) {
      this.page = val
      this.getData()
    },
    cancelLink(row, item, index) {
      this.$confirm('删除关联的同时，会删除已关联的附件', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await app.service('project').wechatFileCancelLink({
            id: row._id,
            link: item.link,
          })
          row.links.splice(index, 1)
          await app.service('project').removeOssAttachment({ file: row, idField: item.idField, id: item.id })
        })
        .catch(e => {
          console.error(e)
        })
    },
    async querySearch(queryString, cb) {
      if (!this.initUserOptions) {
        const users = await app.service('project').simpleUsers()
        const options = users.map((val, index) => ({
          label: val.account,
          value: val.account,
        }))
        this.userOptions = options
        this.initUserOptions = true
      }
      const userOptions = this.userOptions || []
      const results = queryString
        ? userOptions.filter(val => val.label && val.label.toLowerCase().includes(queryString.toLowerCase()))
        : userOptions
      cb(results)
    },
    showRadishDetail({ id, title }) {
      if (!id) return
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    onSelectionChange(val) {
      this.selection = val
    },
    async exportExcel() {
      if (this.exportPending) return
      const selection = this.selection
      if (selection.length === 0) return
      let workbook

      const fieldColIndex = {}
      const formatedResult = selection.forEach((file, row) => {
        const _file = objectPickBy(
          file,
          (value, key) => !['_id', '__requestSender', '__requestId', 'links', 'fileurl'].includes(key),
        )
        if (_file.createdAt) dateFormat(new Date(_file.createdAt), 'yyyy-mm-dd')
        const exportFields = Object.keys(_file)
        if (!workbook) {
          workbook = initialize2DArray(exportFields.length, selection.length + 1)
          workbook[0] = exportFields.map(field => i18n[field] || field)
          exportFields.forEach((field, col) => {
            if (!fieldColIndex[field]) {
              fieldColIndex[field] = col
            }
          })
        }
        exportFields.forEach(field => {
          workbook[row + 1][fieldColIndex[field]] = _file[field]
        })
      })
      try {
        this.exportPending = true
        const url = await window.app.service('file').exportExcel({
          name: '文件',
          workbook,
        })
        download({ url })
      } catch (error) {
        this.$message.error((error.response && error.response.message) || error.message)
      }
      this.exportPending = false
    },
    showDialog(row) {
      const { type, filename } = row
      this.fileType = type
      this.linkTarget = Object.assign({}, row)
      this.dialogVisible = true
      this.searchKeywords = filename ? filename.split('.')[0] : ''
    },
    async confirmLink(linkItem) {
      try {
        const links = Array.from(this.linkTarget.links)
        links.push(linkItem)
        await app.service('project').updateWechatFileLink({ id: this.linkTarget._id, links })
        const rowIndex = this.list.findIndex(({ _id }) => _id === this.linkTarget._id)
        if (rowIndex > -1) this.list[rowIndex].links = links
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
  },
}
</script>
